import Reveal from '../components/Reveal';
import { CASE_STUDIES } from '../data';

import rdLogo   from '../assets/client_royaldivine.jpeg';
import rpLogo   from '../assets/client_redplanet.jpeg';
import siLogo   from '../assets/client_soldinsight.webp';
import srdLogo  from '../assets/client_srd.png';
const CLIENT_LOGOS = { 'client_royaldivine.jpeg': rdLogo, 'client_redplanet.jpeg': rpLogo, 'client_soldinsight.webp': siLogo, 'client_srd.png': srdLogo };

export default function Portfolio({ openForm }) {
  return (
    <div style={{ paddingTop: 90 }}>
      <section className="section">
        <div className="container">
          <Reveal>
            <span className="tag">Case Studies</span>
            <h1 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(32px,5vw,62px)', fontWeight: 900, marginBottom: 16 }}>
              Real Results,<br />Real Estate.
            </h1>
            <p style={{ color: 'var(--mut)', fontSize: 18, maxWidth: 520, lineHeight: 1.8, marginBottom: 64 }}>
              ₹40L+ in managed ad spend. A proven track record across India's leading developers and channel partners.
            </p>
          </Reveal>

          {CASE_STUDIES.map((cs, i) => (
            <Reveal key={i} delay={0.05}>
              <div style={{ background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 22, padding: 44, marginBottom: 28, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 52, alignItems: 'start' }}>
                <div>
                  {/* Client header */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 28 }}>
                    <div style={{ width: 64, height: 64, borderRadius: 14, overflow: 'hidden', background: '#000', border: '1px solid rgba(255,255,255,0.12)', flexShrink: 0 }}>
                      <img src={CLIENT_LOGOS[cs.logo]} alt={cs.client} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div>
                      <h2 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 22 }}>{cs.client}</h2>
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: cs.color + '18', border: `1px solid ${cs.color}30`, color: cs.color, padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', marginTop: 4 }}>
                        {cs.type}
                      </div>
                    </div>
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--mut)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 8 }}>The Challenge</div>
                    <p style={{ fontSize: 15, lineHeight: 1.8, color: 'var(--txt)' }}>{cs.challenge}</p>
                  </div>
                  <div style={{ marginBottom: 28 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--mut)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 8 }}>Our Solution</div>
                    <p style={{ fontSize: 15, lineHeight: 1.8, color: 'var(--txt)' }}>{cs.solution}</p>
                  </div>
                  <div style={{ background: 'var(--bg3)', borderLeft: `3px solid ${cs.color}`, borderRadius: '0 10px 10px 0', padding: '18px 22px', fontStyle: 'italic', color: 'var(--mut)', fontSize: 15, lineHeight: 1.7 }}>
                    "{cs.quote}"
                  </div>
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--mut)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 18 }}>Key Results</div>
                  {cs.metrics.map((m, j) => (
                    <div key={j} style={{ background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 14, padding: '20px 24px', marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ fontFamily: 'var(--fD)', fontSize: 36, fontWeight: 900, color: cs.color, lineHeight: 1 }}>{m.val}</div>
                      <div style={{ fontWeight: 600, fontSize: 15, textAlign: 'right', color: 'var(--txt)' }}>{m.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}

          <div style={{ textAlign: 'center', marginTop: 52 }}>
            <Reveal>
              <h2 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 'clamp(26px,4vw,46px)', marginBottom: 16 }}>Ready to see your growth story?</h2>
              <button onClick={openForm} className="btn btn-teal" style={{ fontSize: 16, padding: '16px 32px' }}>Contact Us Today →</button>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
